import { PresetOptionData } from './Preset.interface';

export const SECTEUR_AGRICOLE: PresetOptionData = {
    label: 'Agricole',
    value: '13',
};

export const SECTEUR_ASSOCIATIONS: PresetOptionData = {
    label: 'Associations',
    value: '8',
};

export const SECTEUR_HOTELLERIE: PresetOptionData = {
    label: 'Métiers de l\'hôtellerie',
    value: '14',
};

export const SECTEUR_RESTAURATION: PresetOptionData = {
    label: 'Métiers de la restauration',
    value: '2',
};

export const SECTEUR_CULTURE_SPORT_LOISIRS: PresetOptionData = {
    label: 'Métiers de la culture, du sport et des loisirs',
    value: '7',
};

export const SECTEUR_INDUSTRIE: PresetOptionData = {
    label: 'Métiers de l\'industrie',
    value: '12',
};

export const SECTEUR_INFORMATIQUE: PresetOptionData = {
    label: 'Métiers de l\'informatique',
    value: '5',
};

export const SECTEUR_SERVICE_A_LA_PERSONNE: PresetOptionData = {
    label: 'Métiers de services à la personne',
    value: '6',
};

export const SECTEUR_BATIMENT: PresetOptionData = {
    label: 'Métiers du bâtiment',
    value: '3',
};

export const SECTEUR_COMMERCE_ARTISANAT: PresetOptionData = {
    label: 'Métiers du commerce et de l\'artisanat',
    value: '1',
};

export const SECTEUR_TRANSPORT_HORS_VTC: PresetOptionData = {
    label: 'Métiers du transport (Hors VTC)',
    value: '4',
};

export const SECTEUR_LIBERALES_ET_REGLEMENTEES_HORS_SANTE: PresetOptionData = {
    label: 'Professions libérales et réglementées (hors santé)',
    value: '10',
};

export const SECTEUR_MEDICALES_ET_PARAMEDICALES: PresetOptionData = {
    label: 'Professions médicales et paramédicales',
    value: '11',
};

export const SECTEUR_CONSEIL_ET_SERVICE: PresetOptionData = {
    label: 'Sociétés de conseil et de service',
    value: '9',
};

export const SECTEUR_VTC: PresetOptionData = {
    label: 'VTC',
    value: 'VTC',
};
export const SECTEUR_COURSIER_VTC: PresetOptionData = {
    label: 'Coursiers et VTC',
    value: 'VTC',
};

export const SECTEUR_AUTRE: PresetOptionData = {
    label: 'Autre',
    value: '0',
};

export const OPTIONS_FOR_SECTOR: ReadonlyArray<PresetOptionData> = [
    SECTEUR_AGRICOLE,
    SECTEUR_ASSOCIATIONS,
    SECTEUR_RESTAURATION,
    SECTEUR_HOTELLERIE,
    SECTEUR_CULTURE_SPORT_LOISIRS,
    SECTEUR_INDUSTRIE,
    SECTEUR_INFORMATIQUE,
    SECTEUR_SERVICE_A_LA_PERSONNE,
    SECTEUR_BATIMENT,
    SECTEUR_COMMERCE_ARTISANAT,
    SECTEUR_TRANSPORT_HORS_VTC,
    SECTEUR_LIBERALES_ET_REGLEMENTEES_HORS_SANTE,
    SECTEUR_MEDICALES_ET_PARAMEDICALES,
    SECTEUR_CONSEIL_ET_SERVICE,
    SECTEUR_VTC,
];

export const OPTIONS_FOR_SECTOR_SHORT: ReadonlyArray<PresetOptionData> = [
    SECTEUR_CULTURE_SPORT_LOISIRS,
    SECTEUR_RESTAURATION,
    SECTEUR_SERVICE_A_LA_PERSONNE,
    SECTEUR_CONSEIL_ET_SERVICE,
    SECTEUR_COMMERCE_ARTISANAT,
    SECTEUR_COURSIER_VTC,
    SECTEUR_AUTRE,
];
